import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const fetchLocations = async () => {
    const response = await apiFetch(`${API_BASE}/locations/operator`);
    if (!response.ok) throw new Error("Не вдалося завантажити локації");
    return await response.json();
};

export const updateLocation = async (id, data) => {
    const response = await apiFetch(`${API_BASE}/locations/operator/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити локацію");
    }
    return response.json();
};

export const addLocation = async (data) => {
    const response = await apiFetch(`${API_BASE}/locations/operator`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати локацію");
    }
    return response.json();
};